import config from './config.json'
import { Config } from './apiInterfaces'

const API_CONFIG: Config = config;

export const API_PROTOCOL: string = API_CONFIG.protocol;
export const API_HOST: string = API_CONFIG.host;
export const API_PORT: string = API_CONFIG.port;
export const API_PATH: string = API_CONFIG.api;

export const API: string = `${API_PROTOCOL}://${API_HOST}:${API_PORT}${API_PATH}`;

export const API_POST_ENDPOINTS: { [key: string]: string } = {
    SIGN_UP: `${API}/register`,
    POST_SCOUT: `${API}/scout-data`,
    POST_CENSUS: `${API}/census`,
}

export const API_GET_ENDPOINTS: { [key: string]: string } = {
    // GET
    ACCOUNT_STATUS: `${API}/account/status`,
    GET_ID: `${API}/account/id`,
    REFRESH_ACCOUNT: `${API}/account/refresh`,
    
    // GET BY ID
    GET_INSTRUCTOR: `${API}/instructor`,
    GET_SCOUT: `${API}/scout-data`,
    GET_CENSUS: `${API}/census/instructor`,
    GET_LEADER_CENSUSES: `${API}/censuses-by-superior`,
    GET_CENSUS_FOR_LEADER: `${API}/censuses-by-superior/id`,
    GET_SCOUT_DISTRICTS: `${API}/instructor/unit/unders`,
    GET_SCOUT_REGIONS: `${API}/units-scout-regions`,
    
    // OTHER
    REDIRECT_TO_GOOGLE: `${API}/redirect-to-google`,
    LOGIN_GOOGLE: `${API}/google-login`,
}

export const API_PUT_ENDPOINTS: { [key: string]: string } = {
    UPDATE_SCOUT: `${API}/scout-data`,
    UPDATE_CENSUS_STATE: `${API}/census-state`,
    UPDATE_COMMENTS_READ: `${API}/census/comments/instructor`,
}

export const API_POOL_ENDPOINT: string = `${API}/pool`;
export const API_POOL_TIMEOUT: number = 10 * 1000 * 10; // 10s
export const API_POOL_INTERVAL: number = 1000; // 1s 
